import axios from "axios";
// const baseUrl = process.env.REACT_APP_API_URL;
import { ApiUrl } from "services/Api";

const API = ApiUrl.Language;

export function getAll() {
  return axios[API.GetAll.Method](API.GetAll.Url);
}
